import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '@fgb/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  isHelpOpen: boolean = false;

  private routerSubscription: Subscription;
  public isCollapsed = true;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => (this.isCollapsed = true))
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  openLanguageSelector(event: Event, countryRow: HTMLElement): void {
    const target = event.target as HTMLElement;
    if (target.closest('.language-dropdown-btn')) {
      return;
    }
    countryRow.querySelector<HTMLElement>('.language-dropdown-btn')?.click();
  }

  logout() {
    this.authService
      .logout()
      .toPromise()
      .then(() => this.router.navigate(['/login']));
  }
}
